import { isUndefined } from "es-toolkit";
import { isArray } from "es-toolkit/compat";
/**
 * Filter values by a property value
 * Useful for filtering union typed arrays,
 */
export function filterBy(values, prop, value) {
    return values.filter(v => v[prop] === value);
}
/**
 * Find value by id property
 */
export function findById(values, id) {
    return values.find(v => v.id === id);
}
export function normalizeToArray(value) {
    if (isArray(value)) {
        return value;
    }
    if (isUndefined(value)) {
        return [];
    }
    return [value];
}
